import { useRouter } from 'next/router'
import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import Seo from 'components/seo'
import Footer from 'components/footer'
import DisplayGrid from 'components/shop/categoriePageDisplay/grid'
import DisplayList from 'components/shop/categoriePageDisplay/list'

import { getCollection, getCollections } from 'lib/shop/api/products'

export default function servicePage({ collection }) {
  const router = useRouter()

  if (router.isFallback) {
    return <div>loading</div>
  }

  return (
    <>
      <Seo
        title={`${collection.title}`}
        description={collection.description}
        canonical={`/shop/categorie/${collection.handle}`}></Seo>
      <div className="">
        <Navbar />
        <main className="mt-12 md:mt-24">
          <Layout>
            <h1 className="text-center font-serif text-4xl font-bold">{collection.title}</h1>

            <div className="mt-8">
              <Textlayout>
                <p
                  className="space-y-4 text-justify text-lg leading-tight"
                  dangerouslySetInnerHTML={{ __html: collection.descriptionHtml }}
                />
              </Textlayout>
            </div>
          </Layout>

          <div className="mt-24">
            {collection.displayAsList?.value === 'false' ? (
              <DisplayGrid collection={collection} />
            ) : (
              <DisplayList collection={collection} />
            )}
          </div>
        </main>
        <div className="mt-24">
          <Footer />
        </div>
      </div>
    </>
  )
}

export async function getStaticProps(context) {
  const collection = await getCollection({ handle: context.params.slug })

  return {
    props: {
      collection
    },
    revalidate: 60 * 5
  }
}

export async function getStaticPaths() {
  const collections = await getCollections()

  return {
    paths: collections.edges.map(({ node: thisCollection }) => ({
      params: { slug: thisCollection.handle }
    })),
    fallback: false
  }
}
